import React from 'react';
import './Testimonial.css'; // Import your CSS file

const TestimonialsSection = () => {
    return (
        <section className="testimonials-section">
            <div className="container">
                <h2 className="heading">Trusted by Homeowners and Businesses</h2>
                <ul className="testimonial-list">
                    <h4 className='testdischead'>Read What Our Customers Say</h4>
                    <div className="border-section">
                        {testimonials.map((testimonial, index) => (
                            <li key={index} className="testimonial-item">
                                "{testimonial}"
                            </li>
                        ))}</div>
                </ul>
            </div>
        </section>
    );
};

const testimonials = [
    "The team was professional, efficient, and left our home spotless. We're thrilled with the results!",
    "Their expertise in basement waterproofing is unmatched. We no longer have to worry about water damage.",
    "Highly recommend their roof waterproofing services. It's been 2 years and we haven't had a single leak!"
];

export default TestimonialsSection;
